import Moment from 'moment';
import {hasTimeLocking, hasTimeApproval} from '../../../forecast-app/shared/util/FeatureUtil';
import {canEditTimeReg} from '../../../forecast-app/my-work-tab/my-timesheets-page/bottom-section/TimeApprovalLockLogic';

// `person` is optional; when provided, a person-level exclusion suppresses the company lock for
// that person. Existing single-arg callers (no person in scope) keep applying the company lock
// unconditionally, since `undefined?.excludeFromCompanyLockedPeriod` is falsy.
export const getCompanyLockedDate = (company, person) => {
	if (hasTimeLocking(company.modules)) {
		return (
			!person?.excludeFromCompanyLockedPeriod &&
			company.lockedPeriodYear &&
			Moment({y: company.lockedPeriodYear, M: company.lockedPeriodMonth - 1, d: company.lockedPeriodDay})
		);
	}
};

export const getLockedDate = (company, person) => {
	if (hasTimeLocking(company.modules)) {
		const companyLockDate = getCompanyLockedDate(company, person);
		if (hasTimeApproval(company.modules)) {
			const personLockDate =
				person?.submitLockedDateYear &&
				Moment({y: person.submitLockedDateYear, M: person.submitLockedDateMonth - 1, d: person.submitLockedDateDay});
			if (!personLockDate && !companyLockDate) return undefined;
			if (!personLockDate || !companyLockDate) return personLockDate || companyLockDate;

			return personLockDate.isAfter(companyLockDate) ? personLockDate : companyLockDate;
		}

		return companyLockDate;
	}
};

// The lock date that applies to one existing time reg, read from its `approvalStatus` and its
// `person`. It follows the server's per-row rule (shouldBypassPersonLockDate in TimeRegLogic):
// the owner's own submission date holds only a row they can no longer change - submitted,
// approved or invoiced, except submitted or approved idle time, which stays the owner's. A row
// that is still theirs (declined, pending, not submitted) is held only by the company-wide lock.
//
// Deliberately per row, and wider than "declined": with the new approval statuses off, the API
// reports a declined row as NOT_SUBMITTED, so a declined-only check would lock it again. The My
// Timesheets grid decides per week instead (getEffectiveLockedDate), so a not-submitted row in an
// otherwise submitted week is unlocked here but locked on the grid; the server accepts the edit.
//
// A missing status fails closed. canEditTimeReg reads it as a new, unsaved row, but every saved
// row has one, so here it can only mean the caller did not fetch the field.
export const getTimeRegLockedDate = (company, timeReg) =>
	timeReg.approvalStatus != null && canEditTimeReg(timeReg)
		? getCompanyLockedDate(company, timeReg.person)
		: getLockedDate(company, timeReg.person);
